import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TopNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="border-b border-stone-200 bg-white/80 backdrop-blur sticky top-0 z-30" data-testid="top-nav">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2" data-testid="brand-home-link">
          <div className="w-9 h-9 rounded-lg bg-stone-900 text-white flex items-center justify-center font-extrabold tw-display">T</div>
          <div>
            <div className="font-extrabold tw-display tracking-tight text-lg leading-none">TAWBTI</div>
            <div className="text-[10px] tracking-[0.25em] text-stone-500 font-bold mt-1">TIPPS ADAMS WEB-BASED TRAINING</div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          {user && (
            <>
              <Link to="/dashboard" className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-stone-700 hover:text-stone-900" data-testid="nav-dashboard">
                <LayoutDashboard size={16}/> Dashboard
              </Link>
              <Link to="/catalog" className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-stone-700 hover:text-stone-900" data-testid="nav-catalog">
                Catalog
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-stone-700 hover:text-stone-900" data-testid="nav-admin">
                  <ShieldCheck size={16}/> Admin
                </Link>
              )}
              <div className="flex items-center gap-2 pl-3 border-l border-stone-200">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-8 h-8 rounded-full object-cover"/>
                ) : (
                  <div className="w-8 h-8 rounded-full bg-stone-200 flex items-center justify-center text-xs font-bold">{(user.name||"?")[0]}</div>
                )}
                <span className="text-sm font-medium hidden sm:block" data-testid="nav-user-name">{user.name}</span>
                <button onClick={async ()=>{ await logout(); nav("/"); }} className="ml-2 p-2 rounded-full hover:bg-stone-100" data-testid="logout-btn" title="Sign out">
                  <LogOut size={16}/>
                </button>
              </div>
            </>
          )}
          {!user && (
            <>
              <Link to="/login" className="text-sm font-semibold" data-testid="nav-login">Sign in</Link>
              <Link to="/register" className="tw-btn-primary text-sm" data-testid="nav-register">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
